<template>
    <footer id="footer" v-if="$route.name !== 'register' && $route.name !== 'login' && $route.name !== 'lookup'">
        <iframe
          class="iframe-footer"
          name="__main"
          src="https://app.orbitly.io/footer"
          noresize
          frameborder="0"
        />
      </footer>
</template>

<script>
export default {
  name: 'footer_component'
}
</script>
